// Temporary services data for DetailedServices component

export const DISPLAY_SERVICES = [
    {
        slug: "it-support",
        title: "IT Support & Managed Services",
        shortDescription: "Proactive, comprehensive IT support and management ensuring your business operations run smoothly and securely 24/7 without interruption.",
        image: "/images/services-img/it_support.webp"
    },
    {
        slug: "wired-networking",
        title: "Wired Networking Solutions",
        shortDescription: "Enterprise-grade wired network infrastructure designed for maximum reliability, speed, and scalable performance across your organization.",
        image: "/images/services-img/wired_network.webp"
    },
    {
        slug: "wifi-networking",
        title: "Wi-Fi Networking Solutions",
        shortDescription: "Seamless, high-speed wireless coverage using advanced UniFi and Ruijie technologies to keep your team connected anywhere in the building.",
        image: "/images/services-img/wifi_networking.webp"
    },
    {
        slug: "cctv-installations",
        title: "CCTV & Security Systems",
        shortDescription: "Professional, high-definition security surveillance solutions featuring intelligent remote monitoring to protect your assets round-the-clock.",
        image: "/images/services-img/cctv.webp"
    },
    {
        slug: "pabx-systems",
        title: "PBX Systems",
        shortDescription: "Advanced PBX and VoIP telephony solutions engineered for crystal-clear, seamless communication both internally and with your clients.",
        image: "/images/services-img/pbx_system.webp"
    },
    {
        slug: "access-control",
        title: "Access Control Systems",
        shortDescription: "Sophisticated access control systems implementing biometric and card-based entry to ensure secure, restricted access to your premises.",
        image: "/images/services-img/access_control.webp"
    },
];
